import { css } from '@emotion/css';
import {
  Black,
  m,
  MobileHeading,
  mobileMediaQuery,
  nonMobileMediaQuery,
} from '@snapchat/snap-design-system-marketing';

import { mediaQuery } from '../../../../styles/mediaQueries';
import { ScreenSize } from '../../../../styles/screenSizes';

export const boundaryCss = css`
  margin-left: auto;
  margin-right: auto;
  max-width: ${ScreenSize.width_1440_desktop_large}px;
  width: 100%;
  padding: ${m('--spacing-xl')};

  ${mobileMediaQuery} {
    padding: ${m('--spacing-m')};
  }
`;

export const filtersContainerCss = css`
  display: flex;

  ${mobileMediaQuery} {
    flex-direction: column;
  }
`;

export const filterContainerCss = css`
  display: flex;
  justify-content: space-between;
  flex-direction: column-reverse;
  gap: ${m('--spacing-m')};

  ${mediaQuery.over1024_desktop_medium} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

/** Wraps filter multiselects; grows vertically when chips wrap. */
export const jobFiltersBlockCss = css`
  width: 100%;
  min-width: 0;

  ${mediaQuery.over1024_desktop_medium} {
    flex: 1;
  }
`;

/** Wraps the keyword search bar; stays its natural height next to filters (no vertical stretch). */
export const jobSearchBarBlockCss = css`
  width: 100%;

  ${mediaQuery.over1024_desktop_medium} {
    width: auto;
    flex-shrink: 0;
  }
`;

export const searchSectionCss = css`
  background-color: ${m('--palette-yellow-v100')};
`;

export const searchHeaderCss = css`
  width: 100%;
  text-align: center;
`;

export const dropdownMenuCss = css`
  align-items: center;
  display: flex;
  padding-block: ${m('--spacing-m')};
  margin-inline-end: ${m('--spacing-xl')};
`;

export const tableCss = css`
  table-layout: fixed;
  width: 100%;
`;

export const mobileJobContainerCss = css`
  & > * {
    border-bottom: solid 1px ${m('--palette-gray-v200')};
    margin-top: ${m('--spacing-m')};
  }
`;

export const tableHeaderCss = css`
  background-color: ${m('--palette-plain-white')};
  margin-top: ${m('--spacing-l')};
`;

export const emptyContainerCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
`;

export const spinnerContainerCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-top: ${m('--spacing-m')};
`;

export const jobMultiSelectWrapperCss = css`
  flex: 1;
  min-width: 0;
  max-width: 100%;
  margin-inline-end: ${m('--spacing-xl')};

  ${mobileMediaQuery} {
    margin-inline-end: 0;
    margin-bottom: ${m('--spacing-s')};
    width: 100%;
  }
`;

export const jobMultiSelectCss = css`
  background-color: inherit;
  border: 1px solid transparent;
  border-radius: 8px;

  .searchWrapper {
    padding: 0 40px 0 0;
    min-height: 44px;
    color: ${Black.V200};

    ${nonMobileMediaQuery} {
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
    }

    ${mobileMediaQuery} {
      ${MobileHeading.M400}
      line-height: 28px;
    }

    input {
      color: ${Black.V200};
      font-size: inherit;
      font-weight: inherit;
      line-height: inherit;
      cursor: default;
      min-width: 0px;
      padding-left: ${m('--spacing-xs')};
      flex: 1 1 0%;
    }

    input::placeholder {
      color: ${Black.V200};
      opacity: 1;
    }

    .chip {
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      border-radius: 11px;
      margin: 4px;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .optionListContainer {
    border-radius: 0 0 8px 8px;
    border: 1px solid ${m('--palette-gray-v200')};
    border-top: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    max-width: 100%;

    .option {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
    }
  }
`;

export const jobMultiSelectArrowCss = css`
  svg {
    fill: ${Black.V200};
  }
`;
